import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Container, Typography, CircularProgress, Paper } from '@mui/material'
import { makeGetRequest } from 'utils/api'

export default function PolicyViewer() {
  const { policyType } = useParams()
  const [policy, setPolicy] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchPolicy()
  }, [policyType])

  const fetchPolicy = async () => {
    try {
      setLoading(true)
      const res = await makeGetRequest(`/api/legal/policies/${policyType}`, {}, false)
      if (res.status === 200) {
        setPolicy(res.data)
      } else {
        setError('Politique non trouvée')
      }
    } catch (err) {
      setError('Erreur lors du chargement de la politique')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#00001d' }}>
        <CircularProgress sx={{ color: '#4ab2ff' }} />
      </Container>
    )
  }

  if (error) {
    return (
      <Container sx={{ minHeight: '100vh', backgroundColor: '#00001d', py: 10 }}>
        <Paper sx={{ p: 4, backgroundColor: '#1a1a2e', color: 'white' }}>
          <Typography color="error" variant="h5">{error}</Typography>
        </Paper>
      </Container>
    )
  }

  return (
    <Container maxWidth="md" sx={{ minHeight: '100vh', backgroundColor: '#00001d', py: 5 }}>
      <Paper sx={{ p: 4, backgroundColor: '#1a1a2e', color: 'white' }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#4ab2ff', fontWeight: 'bold' }}>
          {policy?.policy_type_display}
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#888', mb: 4 }}>
          Version {policy?.version} - En vigueur depuis le {new Date(policy?.effective_date).toLocaleDateString('fr-FR')}
        </Typography>
        <Box
          sx={{ 
            mt: 4,
            '& h1, & h2, & h3': { color: '#4ab2ff', mt: 3, mb: 2 },
            '& p': { mb: 2, lineHeight: 1.8 },
            '& ul, & ol': { mb: 2, pl: 3 },
            '& li': { mb: 1 },
            '& a': { color: '#4ab2ff', textDecoration: 'underline' }
          }}
          dangerouslySetInnerHTML={{ __html: policy?.content }}
        />
      </Paper>
    </Container>
  )
}
